<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Promoções" sub="Produtos da Campanha">
      <template v-slot:actions>
        <base-button
          @click="modals.modal0 = true"
          type="neutral"
          class="ml-3"
          size="sm"
        >Inserir Produtos</base-button>
      </template>
    </page-title>
    <modal :show.sync="modals.modal0" id="cadastrar-seções" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Cadastrar item do Pedido</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-12">
              <div>
                <div class="form-group">
                  <label class="form-control-label">Produto</label>
                  <multiselect
                    v-model="order_item.product"
                    :options="products"
                    placeholder="Selecionar Produto"
                    label="description"
                    :select-label="''"
                    :selected-label="'Selecionado'"
                    :deselect-label="''"
                    track-by="id"
                    @input="filterPriceTable($event); updateCostsbyunitaryValue();"
                  >
                    <template v-slot:noResult>Nenhum Resultado Encontrado</template>
                    <template v-slot:noOptions>A Lista está Vazia!</template>
                    <template v-slot:maxElements>O Máximo de Opções foi Atingido. Remova uma Opção Selecionada para Selecionar Outra.</template>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <base-input
                  v-model="order_item.quantity"
                  placeholder="Quantidade KG/L"
                  label="Quantidade"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  @input="updateCostsbyunitaryValue"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <div class="form-group">
                  <label class="form-control-label">Tabela</label>
                  <multiselect
                    v-model="order_item.price_table"
                    :options="selected_price_tables"
                    placeholder="Selecionar Tabela"
                    :select-label="''"
                    :selected-label="'Selecionado'"
                    :deselect-label="''"
                    label="description"
                    track-by="id"
                    @input="updateCostsbyunitaryValue"
                  >
                    <template v-slot:noResult>Nenhum Resultado Encontrado</template>
                    <template v-slot:noOptions>A Lista está Vazia!</template>
                    <template v-slot:maxElements>O Máximo de Opções foi Atingido. Remova uma Opção Selecionada para Selecionar Outra.</template>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker
                  slot-scope="{focus, blur}"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ 
                    allowInput: true, dateFormat: 'd-m-Y',
                    locale: 'pt'
                  }"
                  class="form-control datepicker"
                  v-model="order_item.delivery_date"
                  placeholder="Data de Entrega"
                />
              </base-input>
            </div>
            <div class="col-md-6">
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker
                  slot-scope="{focus, blur}"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ 
                    allowInput: true, dateFormat: 'd-m-Y',
                    locale: 'pt'
                  }"
                  class="form-control datepicker"
                  v-model="order_item.payment_date"
                  placeholder="Data de Pagamento"
                />
              </base-input>
            </div>
            <div class="col-md-12">
              <div>
                <base-input
                  v-model="order_item.total_cost"
                  placeholder="Valor Total"
                  label="Valor Total"
                  type="number"
                  disabled
                />
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false">Fechar</base-button>
        <base-button type="success" @click="save">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <span>Produtos do Pedido </span>
      </div>
     
      <el-table
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="order_items"
        ref="order_items"
      >
        <el-table-column label="Nome Produto" min-width="170px" prop="product.description" sortable/>
        <el-table-column label="Marca" prop="product.brand" min-width="150px" sortable/>
        <el-table-column label="Quantidade" prop="quantity" min-width="150px" sortable/>
        <el-table-column label="Data Pagamento" prop="payment_date" min-width="180px" sortable/>

        <el-table-column label="Valor total" prop="total_cost" min-width="170px" sortable/>
        <el-table-column 
          label="Ações" 
          min-width="120px" 
          prop="acoes" 
          v-slot="{row}">
          <div class="row">
            <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <a class="dropdown-item" href="#" @click="remove(row)">Excluir</a>
              </el-dropdown-menu>
            </el-dropdown>
            <a @click="rowClicked(row, true)">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fa fa-eye mt-2"></i>
              </span>
            </a>
          </div>
        </el-table-column>
        <el-table-column type="expand">
          <template align="right" slot-scope="props">
            <card>
              <h5 class="card-title">Outras informações</h5>
              <p>Preço Unitário: {{ props.row.product_price.base_value }}</p>
            </card>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import { Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown 
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { ValidationProvider, extend } from "vee-validate";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/l10n/pt.js";
import "flatpickr/dist/flatpickr.css";


export default {
  name: "app",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    Multiselect,
    ValidationProvider,
    flatPicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      modals: {
        modal0: false
      },
      products: [], 
      order_items: [],
      product: {},
      order_item: {},
      price_tables: [],
      selected_price_tables: [],
      purchase_order: {},
      filter: {},
      errors: [],
      filtered: false,
      paginated_data: [],
      formData: {},
      expanded_row: {},
    }
  },
  created() {
    this.setStaticData();
  },
  methods: {
    rowClicked(row) {
      console.log("clickou")
      if (this.expandedRow !== row){
        this.$refs.order_items.toggleRowExpansion(this.expandedRow);
        this.expandedRow = row;
      } else {
        this.expandedRow = null;
      }

      this.$refs.order_items.toggleRowExpansion(row);
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    setData(q, page) {
      //  Adicionando valores default a query e ao número da página se não definidos

      if (typeof page === "undefined") page = 1;
      if (typeof q === "undefined" || this.emptyFilter) q = null;
    
      this.$http.secured
        .get(`/api/v1/purchase_orders/${this.purchase_order.id}/order_items`, {
          params: {
            purchase_order_id: this.purchase_order.id,
            page: page,
            q: q
          }
        })
        .then(response => {
          // setando dados de paginação e a collection produtos
          this.paginated_data = response.data;
          this.order_items = this.paginated_data["order_items"];
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    setStaticData(){
      this.setPurchaseOrder();
      this.setProducts();
      this.setPriceTables();
    }, 
    async save() {
      const validForm = await this.$refs.observer.validate()
      if(!validForm) {
        console.log("invalid Form");
        return;
      }
      
      this.$http.secured(this.reqParams)   
        .then(response => {
          console.log("response: ",response.data)
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.modals.modal0 = false;
          this.resetInputs()
          this.$refs.observer.reset();
        })
        .catch(error => {
          this.setError(error, "Cannot save Sector")
          this.$refs.observer.setErrors(this.errors)
        });
    },
    setProducts() {
      this.$http.secured
        .get("/api/v1/products")
        .then(response => {
        // setando dados de paginação e a collection produtos
        // this.paginated_data = response.data;
        // console.log("products: ", response.data)
        this.products = response.data.products;
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    remove(order_item) {
      this.$http.secured
        .delete(`/api/v1/purchase_orders/${this.purchase_order.id}/order_items/${order_item.id}`)
        .catch((error) => this.setError(error, "Cannot delete Ano Safra"));
    },
    setPurchaseOrder() {
      this.$http.secured
        .get(`/api/v1/purchase_orders/${this.$route.params.purchase_order_id}`)
        .then(response => {
          this.purchase_order = response.data;
          this.setData();
        })
        .catch(error => this.setError(error, "failed to fetch branches"));
    },
    setPriceTables() {
      this.$http.secured
        .get("/api/v1/price_tables")
        .then(response => {
        // setando dados de paginação e a collection produtos
        // this.paginated_data = response.data;
        this.price_tables = response.data;
        this.selected_price_tables = this.price_tables;
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData(filterInput, page);
    },
    resetInputs() {
      this.filter      = {}
      this.order       = {}
      this.order_item  = {}
    },
    async filterPriceTable(product) {
      const params   = { q: { product_id: product.id } }
      const response = await this.$http.secured.get("/api/v1/price_tables", { params: params })

      this.selected_price_tables = response.data
    },
    async getProductPrice(productId, priceTableId) {
      const params   = { q: { product_id: productId, price_table_id: priceTableId } }
      const response = await this.$http.secured.get("/api/v1/product_prices", { params: params })
    
      return response.data.product_prices[0]
    },
    async updateCostsbyunitaryValue() {
      if (await this.updateUnitaryValue()) this.computeCosts();
    },
    async updateUnitaryValue(){
      if(!this.order_item.quantity || !this.order_item.price_table || !this.order_item.product)
        return false

      const productPrice           = await this.getProductPrice(this.order_item.product.id, this.order_item.price_table_id)
      this.order_item.unit_value   = productPrice.base_value;
      this.order_item.max_discount = productPrice.discount;

      return true
    },
    computeCosts() {
      this.$set(this.order_item, "total_cost", this.order_item.unit_value * this.order_item.quantity)
    },
  },
  computed: {
    reqParams: function() {
      if(this.order_item.hasOwnProperty('id')) {
        return {
          url: `/api/v1/purchase_orders/${this.purchase_order.id}/order_items/${this.order_item.id}`,
          method: 'patch',
          data: {order_item: this.normalizedItem},
        }
      }

      return { 
        url: `/api/v1/purchase_orders/${this.purchase_order.id}/order_items`,
        method: 'post',
        data: {order_item: this.normalizedItem},
      }   
    },
    emptyFilter: function() {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    normalizedFilter: function(){
      let filter = this.filter;
      for(let key in filter){
        // replacing objects by ids
        if (
          filter.hasOwnProperty(key) &&
          typeof filter[key] == 'object'
        ) {
          if(filter[key].hasOwnProperty('id')){
            filter[key + '_id'] = filter[key].id
            delete filter[key]
          } else {
            filter[key] = filter[key].value
          }
        }
        // removing empty fields
        if (filter[key] == "") {
          delete filter[key];
        }
      }

      return filter;
    },
    normalizedItem: function() {
      let order_item = this.order_item;
      order_item.product_code = this.order_item.product.code

      for(let key in order_item){
        // replacing objects by ids
        if (
          order_item.hasOwnProperty(key) &&
          typeof order_item[key] == 'object' &&
          order_item[key].hasOwnProperty('id')
        ) {
          order_item[key + '_id'] = order_item[key].id
          delete order_item[key]
        }
        if (
          order_item.hasOwnProperty(key) &&
          typeof order_item[key] == 'object' &&
          order_item[key].hasOwnProperty('tabe_cta')
        ) {
          order_item[key + '_id'] = order_item[key]['tabe_cta']
          delete order_item[key]
        }
        // removing empty fields
        if (order_item[key] == "") {
          delete order_item[key];
        }
      }
      return order_item;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

